/* eslint-disable react-hooks/exhaustive-deps */
import { memo, useEffect, useState } from 'react';
import { getPlanCostFromRatna, getShortFormForPlanInterval } from '@/utils/subscription-utils';
import { JIM_HUBSPOT_MEETING_LINK } from '@Saral-Influencer-Marketing/saral-utils/dist/constants/hubspot.js';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { useSelector } from 'react-redux';

import { useStripeEnv } from '../../../../hooks/useStripeVersion';
import SaralLoader from '../../../../images/saral-loader.gif';
import stripeImage from '../../../../images/subscription/stripe.svg';
import { createPaymentIntent, getTrialDaysCount } from '../../../../services/subscription.service';
import ModalComponent from '../../../common-components/ModalComponent/ModalComponent';
import SaralLoaderImage from '../../../common-components/SaralLoaderImage';
import ConfirmCardSetupForm from './CardSetup';
import SetupForm from './SetupForm';

const options = {
  appearance: {
    theme: 'stripe',
    variables: { borderRadius: '4px' },
    rules: {
      '.TermsText': {
        display: 'none',
        visibility: 'hidden',
        height: 0,
        marginBottom: 10,
      },
      '.Label': { color: '#667085' },
      '.Input': { width: '100%' },
      '.p-TermsText': { display: 'none' },
    },
  },
};

const AddPaymentMehtod = () => {
  const [clientSecret, setClientSecret] = useState(null);
  const [showLoader, setShowLoader] = useState(true);
  const { userDetails } = useSelector((state) => state.user);

  const stripeEnv = useStripeEnv();
  const stripePromise = loadStripe(stripeEnv);
  const useCardSetup = [
    'ram+3ds@getsaral.com',
    'raveen.kapadia@conversionbug.com',
    'mmalmrose@catabox.com',
    'bhupender+test24@getsaral.com',
  ].includes(userDetails.email.toLowerCase());

  const [freeTrialDays, setFreeTrialDays] = useState('');
  let referral = localStorage.getItem('referral');
  referral = referral ? JSON.parse(referral) : {};

  let planType = localStorage.getItem('planType');
  planType = planType ? JSON.parse(planType) : {};
  let ratna = localStorage.getItem('ratna');
  ratna = ratna ? JSON.parse(ratna) : {};
  const getFreeTrialDaysCount = async () => {
    const body = { ...referral };
    const response = await getTrialDaysCount(body);
    if (response?.status) {
      setFreeTrialDays(response.data.freeTrialDays);
    }
  };

  const getPaymentSecret = async () => {
    const data = await createPaymentIntent();
    setClientSecret(data?.clientSecret);
    setShowLoader(false);
  };

  useEffect(() => {
    getFreeTrialDaysCount();
    getPaymentSecret();
  }, []);

  return (
    <>
      <ModalComponent show={true} width={550}>
        <div className="payment-modal-header">
          <h2>Claim your free trial!</h2>
          <p>
            Please enter your credit card details below to get a {freeTrialDays}
            -day free trial. Don&apos;t worry, you won&apos;t be charged now.
          </p>
          {showLoader && (
            <div style={{ display: 'grid', placeItems: 'center', height: 300 }}>
              <SaralLoaderImage />
            </div>
          )}

          {clientSecret && !showLoader && (
            <Elements stripe={stripePromise} options={{ ...options, clientSecret }} key={clientSecret}>
              {useCardSetup ? <ConfirmCardSetupForm clientSecret={clientSecret} /> : <SetupForm />}
            </Elements>
          )}
          <p
            style={{
              paddingTop: '10px',
              fontSize: '13px',
              fontWeight: 400,
              lineHeight: '20px',
            }}>
            Not sure yet?{' '}
            <a href={JIM_HUBSPOT_MEETING_LINK} target="_blank" rel="noopener noreferrer">
              Book a demo
            </a>
          </p>
        </div>
        {clientSecret && !showLoader && (
          <>
            <p className="info-message">
              We will charge your card at the end of {freeTrialDays} days, unless you cancel. SARAL is an investment of
              ${getPlanCostFromRatna(planType?.value || 'monthly', ratna?.value || 300)}/
              {getShortFormForPlanInterval(planType?.value || 'monthly') || 'mo'} for all-access!
            </p>
            <div className="bottom-stripe-container">
              <img src={stripeImage} alt="stripe" width={300} />
            </div>
          </>
        )}
      </ModalComponent>
    </>
  );
};

export default memo(AddPaymentMehtod);
